import React from "react";
import styles from "./Footer.module.css";
import Typography from "@material-ui/core/Typography";

const Footer = () => {
  return (
    <>
      <div className={styles.FooterWrapper}>
        <Typography varainat="h4" className={styles.FooterText}>
          Copyright
        </Typography>
      </div>
    </>
  );
};

export default Footer;
